import { HttpClient } from "@/shared/services";

class StudentFilesService {
  endpoint = "students";

  async import(file) {
    try {
      const res = await HttpClient.post(`${this.endpoint}/import` , file);
      return res.data;
    } catch (err) {
      throw err(err);
    }
  }
}

export default new StudentFilesService();
